exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footerAsset[data-v-6bd4da12]{margin:auto;display:-ms-grid;display:grid}.button.is-danger[data-v-6bd4da12]{border-radius:0}.scrollx[data-v-6bd4da12]{width:100%;overflow-x:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bd4da12","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/index.vue
// module id = 36
// module chunks = 4